export type GeneralErrorTranslation = {
  forbidden: ErrorTranslation;
  general: ErrorTranslation;
  goBack: string;
  http: {
    404: string;
    500: string;
  };
  loadingNewVersion: string;
  logIn: string;
  newVersionLoadFailed: ErrorTranslation;
  notAuthorized: ErrorTranslation;
  notFound: ErrorTranslation;
  phoneOrEmailRequired: string;
  refresh: string;
  waitingForApproval: ErrorTranslation;
};

type ErrorTranslation = {
  message: string;
  subMessage?: string;
};

export const generalErrorTranslation: GeneralErrorTranslation = {
  forbidden: {
    message: 'Nie masz dostępu do tego zasobu',
    subMessage: 'Jeżeli uważasz, że to błąd, skontaktuj się ze swoim przełożonym',
  },
  general: {
    message: 'Wystąpił nieoczekiwany błąd',
    subMessage: 'Nasz zespół został poinformowany. Spróbuj ponownie później.',
  },
  goBack: 'Wróć',
  http: {
    404: 'Nie znaleziono żądanego zasobu',
    500: 'Wystąpił nieoczekiwany błąd',
  },
  loadingNewVersion: 'Wczytujemy nową wersję aplikacji…',
  logIn: 'Zaloguj się',
  newVersionLoadFailed: {
    message: 'Nie udało się wczytać nowej wersji aplikacji',
    subMessage: 'Odśwież stronę. Jeśli to nie pomoże, spróbuj ponownie za chwilę.',
  },
  notAuthorized: {
    message: 'Twoja sesja wygasła',
    subMessage: 'Za chwilę nastąpi przekierowanie na stronę logowania',
  },
  notFound: {
    message: 'Strona nie istnieje!',
  },
  phoneOrEmailRequired: 'Numer telefonu lub email jest wymagany',
  refresh: 'Odśwież',
  waitingForApproval: {
    message: 'Twoje konto oczekuje na zatwierdzenie',
    subMessage: 'Poinformujemy Cię, gdy zostanie zatwierdzone.',
  },
};
